module.exports = __webpack_public_path__ + "img/webcam.532864fe.gif";